import React from 'react';
import styles from './FilterTable.module.css';
import { Row, Col } from 'antd';
import { Form, Field } from 'react-final-form';
import { FilterDataJamProps } from 'module/Report/Ringkasan/container/JamPengiriman';

import SelectField from 'components/SelectField';
import InputDatePicker from 'components/InputDatePicker';
import Button from 'components/Button';
import CardMaterial from 'materials/CardMaterial';
import moment from 'moment-timezone';

type FilterTableProps = {
  dataAllBranch: Array<any>;
  isLoadingBranch?: boolean;
  roleAccount: string;
  selectedBranchId: number | null | undefined;
  dataFilterJam: FilterDataJamProps;
  handleResetFilter: () => void;
  handleSubmitFilter: (value: FilterDataJamProps) => void;
};

export default function FilterTable({
  dataAllBranch,
  isLoadingBranch,
  roleAccount,
  selectedBranchId,
  dataFilterJam,
  handleResetFilter,
  handleSubmitFilter,
}: FilterTableProps) {
  const isBranch = roleAccount === 'Branch';
  const defaultDateSend = isBranch ? moment().subtract(1, 'weeks') : null;
  return (
    <CardMaterial
      title={<b style={{ color: '#11BEFF' }}>RINGKASAN JAM PENGIRIMAN</b>}
      style={{ borderRadius: '10px' }}
    >
      <Form
        initialValues={{
          dateSend: dataFilterJam.dateSend,
          branch: dataFilterJam.branch,
          dateEnd: dataFilterJam.dateEnd,
        }}
        validate={values => {
          const errors = {} as any;
          if (!values.dateSend) {
            errors.dateSend = 'Tanggal selesai wajib di isi';
          }
          if (!values.dateEnd) {
            errors.dateEnd = 'Sampai Tanggal wajib di isi';
          }
          return errors;
        }}
        onSubmit={handleSubmitFilter}
      >
        {({ form, handleSubmit, submitting, valid, values }) => (
          <div className={styles.wrapperFilter}>
            <div className={styles.wrapperItemFilter}>
              <Row gutter={24}>
                <Col md={12} className={styles.filterColumn}>
                  <Field name="dateSend">
                    {({ input, meta }) => (
                      <InputDatePicker
                        label="Tanggal Selesai"
                        placeholder="Pilih Tanggal"
                        onOpenChange={input.onBlur}
                        onChange={value => {
                          input.onChange(value);
                        }}
                        value={input.value}
                        error={
                          meta.touched && meta.error !== undefined && meta.error
                        }
                      />
                    )}
                  </Field>
                </Col>
                <Col md={12} className={styles.filterColumn}>
                  <Field name="dateEnd">
                    {({ input, meta }) => (
                      <InputDatePicker
                        label="Sampai Tanggal"
                        placeholder="Pilih Tanggal"
                        onOpenChange={input.onBlur}
                        onChange={value => {
                          input.onChange(value);
                        }}
                        value={input.value}
                        error={
                          meta.touched && meta.error !== undefined && meta.error
                        }
                        disabled={!values.dateSend}
                        disabledDate={d => {
                          return (
                            d.isBefore(
                              moment(values.dateSend)
                                .add(0, 'day')
                                .format('YYYY-MM-DD')
                            ) ||
                            d.isAfter(
                              moment(values.dateSend)
                                .add(31, 'day')
                                .format('YYYY-MM-DD')
                            )
                          );
                        }}
                      />
                    )}
                  </Field>
                  <Field name="branch">
                    {({ input, meta }) => (
                      <SelectField
                        validate
                        label="HUB"
                        placeholder="Semua HUB"
                        data={dataAllBranch}
                        loading={isLoadingBranch}
                        disabled={isBranch || !values.dateSend}
                        value={input.value}
                        onChange={value => {
                          input.onChange(value);
                        }}
                        onBlur={value => {
                          input.onBlur(value);
                        }}
                        validateStatus={
                          meta.error && meta.touched ? 'error' : 'validating'
                        }
                        errorMessage={meta.error && meta.touched && meta.error}
                        mode="multiple"
                        allowClear
                      />
                    )}
                  </Field>
                </Col>
              </Row>
            </div>
            <div className={styles.actionFilter}>
              <Button
                text="Reset"
                variant="danger"
                className={styles.actionWidth}
                onClick={() => {
                  handleResetFilter();
                  form.reset({
                    dateSend: defaultDateSend,
                    //@ts-ignore
                    branch: [selectedBranchId],
                  });
                }}
                disabled={!valid}
              />
              <Button
                text="Cari"
                className={styles.actionWidth}
                onClick={handleSubmit}
                disabled={submitting || !valid}
              />
            </div>
          </div>
        )}
      </Form>
    </CardMaterial>
  );
}
